import { Table } from "@/components/common/Table";
import { getCurrentSeason } from "@/helper/api";
import { getCurrentBundesligaTable } from "@/helper/getRanksForGameday";
import { News } from "@/models/types";

import { LeagueTeam } from "@/models/LeagueTeam";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { Season } from "@/models/Season";

export async function getServerSideProps(context: any) {
  const { res } = context;
  res.setHeader(
    "Cache-Control",
    "public, max-age=300, stale-while-revalidate=360"
  );

  // Parse URL filters
  const enableLinks = context.query.links === "true"; // "true" to enable links (opens in new tab)

  const teams = await getCurrentBundesligaTable();
  const currentSeason = await getCurrentSeason();

  return {
    props: {
      teams,
      currentSeason,
      enableLinks,
      ...(await serverSideTranslations(context.locale)),
    },
  };
}

interface PageProps {
  teams: LeagueTeam[];
  news: News[];
  currentSeason: Season;
  enableLinks: boolean;
}
export default function Page({ teams, currentSeason, enableLinks }: PageProps) {
  return (
    <Table
      teams={teams}
      season={currentSeason}
      disableLinks={!enableLinks}
      openInNewTab={enableLinks}
    />
  );
}
